// Notification sound using Web Audio API - pleasant ding sound
let audioCtx = null;
let soundInitialized = false;

function getAudioContext() {
  if (!audioCtx || audioCtx.state === 'closed') {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

// Initialize audio context on first user interaction (required by browsers)
function initAudioOnInteraction() {
  if (soundInitialized) return;
  const handler = () => {
    try {
      const ctx = getAudioContext();
      if (ctx.state === 'suspended') ctx.resume();
      soundInitialized = true;
    } catch (e) { /* ignore */ }
  };
  document.addEventListener('click', handler, { once: true });
  document.addEventListener('keydown', handler, { once: true });
  document.addEventListener('touchstart', handler, { once: true });
}

// Initialize on load
if (typeof window !== 'undefined') {
  initAudioOnInteraction();
}

export function playNotificationSound() {
  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    const now = ctx.currentTime;

    // Clear, pleasant two-tone "ding-ding" chime
    const tones = [
      { freq: 784, delay: 0 },      // G5
      { freq: 1047, delay: 0.15 },   // C6 (higher)
    ];

    tones.forEach(({ freq, delay }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + delay);

      // Sharper attack, longer sustain for audibility
      gain.gain.setValueAtTime(0, now + delay);
      gain.gain.linearRampToValueAtTime(0.35, now + delay + 0.02);
      gain.gain.setValueAtTime(0.35, now + delay + 0.08);
      gain.gain.exponentialRampToValueAtTime(0.001, now + delay + 0.5);

      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + delay);
      osc.stop(now + delay + 0.6);
    });
  } catch (e) {
    // Silently fail if audio is not available
    console.warn('Notification sound failed:', e);
  }
}
